import { PropsWithChildren } from 'react';

interface Props {
  text: string;
}

export default function Tooltip(props: PropsWithChildren<Props>) {
  return (
    <div className="tooltip">
      {props.children}
      <span className="tooltip__text">{props.text}</span>
    </div>
  );
}
